// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'



import './jquery-global.js';
import './import-global.js';

import './initializers/jquery.plugins.init.js';
import './animations.js';
import './validation.js';



$(function () {
  $('form').parsley();
  const lang =  localStorage.getItem('locale') || 'it';
  if (!localStorage.getItem('locale')) localStorage.setItem('locale', lang);
  Parsley.setLocale(lang);
});

window.confirmDelete = function (url, reload=false) {
  $.ajax({
    method: 'GET',
    url: '/users/swal_translations?format=json',
    success: function (data) {
      if (data.length != 0 && data.confirm_delete) {
        var translations = data.confirm_delete;
        Swal.fire({
          title: translations.title,
          text: translations.text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '<i class="mdi mdi-delete"></i> ' + translations.button_ok,
          confirmButtonAriaLabel: translations.button_ok,
          cancelButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_cancel,
          cancelButtonAriaLabel: translations.button_cancel,
          confirmButtonColor: '#d33',
        })
          .then(({value, dismiss}) => {
            if (value) {
              $.ajax({
                method: 'DELETE',
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
                url: url + '?format=json',
                success: function (data) {
                  if (data.deleted_at) {
                    // Reload table data
                    $('.dataTable').DataTable().ajax.reload();
                    Swal.fire({
                      title: translations.success,
                      type: 'success',
                      confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                      confirmButtonAriaLabel: translations.button_close
                    });
                    $('#installation_item_' + data.id).hide();
                    if (reload) { location.reload(); }
                  } else {
                    location.reload();
                  }
                }
              });
            } else {
              Swal.fire({
                title: translations.canceled,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
          });
      }
    }
  });
};

window.confirmAccreditation = function (accreditation_id, expiration_date) {
  $.ajax({
    method: 'GET',
    url: '/users/swal_translations?format=json',
    success: function (data) {
      if (data.length != 0 && data.confirm_accreditation) {
        var translations = data.confirm_accreditation;
        Swal.fire({
          title: translations.title,
          text: translations.text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '<i class="mdi mdi-check"></i> ' + translations.button_ok,
          confirmButtonAriaLabel: translations.button_ok,
          cancelButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_cancel,
          cancelButtonAriaLabel: translations.button_cancel,
          confirmButtonColor: '#3085d6',
          html: '<label>Conferma la validità dell\'accreditamento fino alla data:</label><div class="input-group"><input type="text" name="expiration_date" class="form-control datepicker-autoclose" placeholder="dd/mm/yyyy" id="expiration_date" value="'+expiration_date+'"> <div class="input-group-append bg-custom b-0"><span class="input-group-text"><i class="mdi mdi-calendar"></i></span></div></div>',
          onOpen: function() {
            $('.datepicker-autoclose').datepicker({});
          }
        })
          .then(({value, dismiss}) => {
            if (value) {
              $.ajax({
                method: 'PUT',
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
                url: '/accreditations/' + accreditation_id + '/confirm?expiration_date='+encodeURIComponent($('#expiration_date').val()),
                success: function (data) {
                  if (data.success) {
                    // Reload table data
                    // $('.dataTable').DataTable().ajax.reload();
                    Swal.fire({
                      title: translations.success,
                      type: 'success',
                      confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                      confirmButtonAriaLabel: translations.button_close
                    });
                     location.reload(); 
                  } else {
                    location.reload();
                  }
                }
              });
            } else {
              Swal.fire({
                title: translations.canceled,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
          });
      }
    }
  });
};

window.confirmTask = function (url, method='POST', reload=false) {
  $.ajax({
    method: 'GET',
    url: '/users/swal_translations?format=json',
    success: function (data) {
      if (data.length != 0 && data.confirm_task) {
        var translations = data.confirm_task;
        Swal.fire({
          title: translations.title,
          text: translations.text,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '<i class="far fa-check-circle"></i> ' + translations.button_ok,
          confirmButtonAriaLabel: translations.button_ok,
          cancelButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_cancel,
          cancelButtonAriaLabel: translations.button_cancel,
          confirmButtonColor: '#0ACF97',
        })
          .then(({value, dismiss}) => {
            if (value) {
              $.ajax({
                method: method,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
                url: url + '?format=json',
                success: function (data) {
                  if (data.response) {
                    // Reload table data
                    $('.dataTable').DataTable().ajax.reload();
                    Swal.fire({
                      title: translations.success,
                      type: 'success',
                      confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                      confirmButtonAriaLabel: translations.button_close
                    });
                    // $('#installation_item_' + data.id).hide();
                    if (reload) { location.reload(); }
                  } else {
                    location.reload();
                  }
                }
              });
            } else {
              Swal.fire({
                title: translations.canceled,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
          });
      }
    }
  });
};

window.cannotDelete = function (code, action) {
  if (code.length > 0) {
    $.ajax({
      method: 'GET',
      url: '/users/swal_translations?format=json',
      success: function (data) {
        if (data.length != 0 ){
          switch( action) {
          case 'cannotEdit':
            if (data.cannot_edit && data.cannot_edit[code]) {
              var translations = data.cannot_edit[code];
              Swal.fire({
                title: translations.title,
                text: translations.text,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
            break;
          case 'cannotEnable':
            if (data.cannot_enable && data.cannot_enable[code]) {
              var translations = data.cannot_enable[code];
              Swal.fire({
                title: translations.title,
                text: translations.text,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
            break;
          case 'noPermission':
            if (data.no_permissions && data.no_permissions[code]) {
              var translations = data.no_permissions[code];
              Swal.fire({
                title: translations.title,
                text: translations.text,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
            break;
          default:
            if (data.cannot_delete && data.cannot_delete[code]) {
              var translations = data.cannot_delete[code];
              Swal.fire({
                title: translations.title,
                text: translations.text,
                type: 'info',
                confirmButtonText: '<i class="mdi mdi-close-circle-outline"></i> ' + translations.button_close,
                confirmButtonAriaLabel: translations.button_close
              });
            }
            break;
          }
        }
      }
    });
  }
};

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

(function ($) {
  'use strict';

  function initSlimscroll () {
    $('.slimscroll').slimscroll({
      height: 'auto',
      position: 'right',
      size: "7px",
      color: '#9ea5ab',
      wheelStep: 5,
      touchScrollStep: 50
    });
  }

  function initTopMenu () {
    $('.navbar-toggle').on('click', function (event) {
      $(this).toggleClass('open');
      $('#navigation').slideToggle(400);
    });

    $('.navigation-menu>li').slice(-2).addClass('last-elements');

    $('.navigation-menu li.has-submenu a[href="#"]').on('click', function (e) {
      if ($(window).width() < 992) {
        e.preventDefault();
        $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
      }
    });
  }

  function initFullScreen () {
    $('#btn-fullscreen').on("click", function (e) {
      e.preventDefault();

      if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    });
  }

  function initLeftMenuCollapse () {
    // Left menu collapse
    $('.button-menu-mobile').on('click', function (event) {
      event.preventDefault();
      $("body").toggleClass("enlarge-menu");
      initSlimscroll();
    });
  }

  function initActiveMenu () {
    // === following js will activate the menu in left side bar based on url ====
    $(".navigation-menu a").each(function () {
      var pageUrl = window.location.href.split(/[?#]/)[0];
      if (this.href == pageUrl) {
        $(this).parent().addClass("active"); // add active to li of the current link
        $(this).parent().parent().parent().addClass("active"); // add active class to an anchor
        $(this).parent().parent().parent().parent().parent().addClass("active"); // add active class to an anchor
      }
    });
  }

  function initSerach () {
    $('.search-btn').on('click', function () {
      var targetId = $(this).data('target');
      var $searchBar;
      if (targetId) {
        $searchBar = $(targetId);
        $searchBar.toggleClass('open');
      }
    });
  }

  function initComponents() {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
  }

  function init () {
    initSlimscroll();
    initTopMenu();
    initFullScreen();
    initLeftMenuCollapse();
    initActiveMenu();
    initSerach();
    initComponents();
    // Waves.init();
  }

  init();
})(jQuery)
